import {SelectPickerDialog} from '@github-ui/filter-picker'

import {useDefaultReposProviders} from './hooks/use-query-definitions'
import {getReposItemConfig} from './ItemConfig'
import type {MultiSelectReposDialogProps, PickerRepository} from './types'

export function MultiSelectReposPickerDialog<TItem extends PickerRepository>(
  props: MultiSelectReposDialogProps<TItem>,
) {
  const {scope, selected, ...restProps} = props
  const itemConfig = getReposItemConfig(scope)
  const providers = useDefaultReposProviders(scope)
  const sortedSelected = selected ? sortMaterializedFirst(selected, itemConfig.isHollow) : undefined

  return (
    <SelectPickerDialog<TItem>
      {...restProps}
      title="Select repositories"
      selectionVariant="multiple"
      providers={providers}
      itemConfig={itemConfig}
      selected={sortedSelected}
    />
  )
}

function sortMaterializedFirst<TItem extends PickerRepository>(
  items: TItem[],
  isHollow: (item: TItem) => boolean,
): TItem[] {
  const materialized: TItem[] = []
  const hollow: TItem[] = []
  for (const item of items) {
    const target = isHollow(item) ? hollow : materialized
    target.push(item)
  }
  materialized.sort((a, b) => a.name.localeCompare(b.name))
  return [...materialized, ...hollow]
}
